import { useState, useEffect } from "react";
import style from "./style.module.scss";
import api from "../../services/api";
import { toast } from "react-toastify";
import useWrapper from "../../hooks/useWrapper";
import Accordion from "../Accordion";
import { Row, Col } from "react-bootstrap";
import TableResponsive from "../TableResponsive";
import useFormat from "../../hooks/utils/useFormat";
import StatusFlag from "../StatusFlag";
import { formatPaymentSlips } from "../../hooks/api/listFinancial";
import InfoModal from "../InfoModal";
import Results from "../Results";
import SumBoxes from "../SumBoxes";

export default function TotalGenerate(props) {
  const { title, commercialId } = props;

  const [loadingPage, setLoadingPage] = useState(true);
  const [bodyContent, setBodyContent] = useState(null);

  const { config } = useWrapper();
  const { formatReal, formatDate } = useFormat();

  useEffect(() => {
    (async () => {
      try {
        setLoadingPage(true);

        const { data } = await api.get(`trainees-by-commercial-with-payments-generated/${commercialId}`, config);

        const _slips = data?.map(__trainees => ({
          ...__trainees,
          paymentSlips: formatPaymentSlips(__trainees.paymentSlips),
          paymentSlipsCancel: formatPaymentSlips(__trainees.paymentSlipsCanceledWithInterest),
        }));

        // 1️⃣ Calcular total geral de todos os boletos
        const _total_geral = _slips?.reduce((__sum_trainees, __trainee) => {
          const _total_trainee = (__trainee.paymentSlips || []).reduce((sum, s) => sum + Number(s.value_raw || 0), 0);
          return __sum_trainees + _total_trainee;
        }, 0);

        const _total_geral_juros = _slips?.reduce((__sum_trainees, __trainee) => {
          const _total_trainee = (__trainee.paymentSlipsCancel || []).reduce(
            (sum, s) => sum + Number(s.value_juros || 0),
            0,
          );
          return __sum_trainees + _total_trainee;
        }, 0);

        const _total_geral_discount_paid = 0;
        // const _total_geral_discount_paid = _slips?.reduce((__sum_trainees, __trainee) => {
        //   const _total_trainee = (__trainee.paymentSlips || []).reduce(
        //     (sum, s) => (s.status == "Pago" ? sum + Number(s.discount || 0) : sum),
        //     0,
        //   );
        //   return __sum_trainees + _total_trainee;
        // }, 0);

        // 2️⃣ Montar JSX do modal
        const body = (
          <div>
            <h2 className="mini-title">Detalhes do Total Gerado</h2>
            <p className="small-label">
              Este relatório apresenta o detalhamento do total financeiro gerado. A apuração considera todos os valores
              originalmente gerados (Total Gerado), subtraindo os juros provenientes de boletos cancelados, resultando
              assim no Resultado Financeiro efetivo.
            </p>
            <Row>
              <Col sm={{ span: 12 }}>
                <Results
                  className="mt-2"
                  rows={[
                    {
                      label: (
                        <>
                          Total Gerado <span className="small-label">( Todos Formandos )</span>
                        </>
                      ),
                      value: formatReal(_total_geral),
                    },
                    {
                      label: (
                        <>
                          Juros (Cancelados) <span className="small-label">( Todos Formandos )</span>
                        </>
                      ),
                      value: formatReal(-1 * _total_geral_juros),
                      type: "dark",
                    },
                    // {
                    //   label: (
                    //     <>
                    //       Descontos (Pagos) <span className="small-label">( Todos Formandos )</span>
                    //     </>
                    //   ),
                    //   value: formatReal(-1 * _total_geral_discount_paid),
                    // },
                    {
                      label: (
                        <>
                          Resultado financeiro <span className="small-label">( Todos Formandos )</span>
                        </>
                      ),
                      value: formatReal(_total_geral - _total_geral_juros - _total_geral_discount_paid),
                    },
                  ]}
                />
              </Col>
            </Row>
            <div className="divisor mt-3 mb-3"></div>
            <h2 className="mini-title">Extrato</h2>
            <p className="small-label mb-2">
              Logo abaixo detalha os valores gerados por formando, incluindo os boletos emitidos e os juros associados
              aos boletos cancelados.
            </p>
            <Accordion>
              {_slips.map((__trainee, __trainee_i) => {
                const slips = __trainee.paymentSlips || [];
                const slipsCancel = __trainee.paymentSlipsCancel || [];
                const _total_trainee = slips?.reduce(
                  (__slip_acc, __slip) => __slip_acc + Number(__slip.value_raw || 0),
                  0,
                );
                const _total_trainee_juros = slipsCancel?.reduce(
                  (__slip_acc, __slip) => __slip_acc + Number(__slip.value_juros || 0),
                  0,
                );
                const _total_trainee_discount_paid = 0;
                // const _total_trainee_discount_paid = slips?.reduce(
                //   (__slip_acc, __slip) =>
                //     __slip.status == "Pago" ? __slip_acc + Number(__slip.discount || 0) : __slip_acc,
                //   0,
                // );

                return (
                  <>
                    <Row key={__trainee.id}>
                      <Col style={{ marginBottom: "16px" }}>
                        <Accordion.Item eventKey={`${__trainee_i}`} data-new-component={true}>
                          <Accordion.Header>
                            <span>{__trainee.name}</span>
                            <SumBoxes
                              className="ms-auto mr-3"
                              elements={[
                                {
                                  label: "Total Gerado",
                                  value: formatReal(_total_trainee || 0),
                                },
                                {
                                  label: "Juros (Cancelados)",
                                  value: formatReal(-1 * _total_trainee_juros || 0),
                                  color: "error",
                                },
                                // {
                                //   label: "Descontos (Pg)",
                                //   value: formatReal(-1 * _total_trainee_discount_paid || 0),
                                //   color: "error",
                                // },
                                {
                                  label: "Resultado",
                                  value: formatReal(
                                    _total_trainee - _total_trainee_juros - _total_trainee_discount_paid || 0,
                                  ),
                                  color: "ok",
                                },
                              ]}
                            />
                          </Accordion.Header>
                          <Accordion.Body>
                            <TableResponsive
                              emptyMsg="Nenhum boleto cadastrado."
                              table={{
                                head: [
                                  { data: "ID", className: style.hide_on_print },
                                  { data: "Valor Original", className: style.provider },
                                  // { data: "Desconto", className: style.provider },
                                  { data: "Vencimento", className: style.provider },
                                  { data: "Rotulo", className: style.provider },
                                  { data: <p className="text-end">Status</p>, className: style.resource },
                                ],
                                body:
                                  slips?.map(__payment => ({
                                    data: [
                                      { element: __payment?.id },
                                      { element: formatReal(__payment.value_raw) },
                                      // { element: formatReal(__payment.discount) },
                                      { element: formatDate(__payment.due_date, 2) },
                                      { element: __payment.label || "?" },
                                      {
                                        element: (
                                          <p className="text-end">
                                            <StatusFlag status={__payment.status} />
                                          </p>
                                        ),
                                      },
                                    ],
                                  })) || [],
                              }}
                            />
                            <TableResponsive
                              emptyMsg="Nenhum boleto com juros em cancelados."
                              table={{
                                head: [
                                  { data: "ID", className: style.hide_on_print },
                                  { data: "Valor Original", className: style.provider },
                                  { data: "Vencimento", className: style.provider },
                                  { data: "Rotulo", className: style.provider },
                                  { data: "Juros", className: style.provider },
                                  { data: <p className="text-end">Status</p>, className: style.resource },
                                ],
                                body:
                                  slipsCancel?.map(__payment => ({
                                    data: [
                                      { element: __payment?.id },
                                      { element: formatReal(__payment.value_raw) },
                                      { element: formatDate(__payment.due_date, 2) },
                                      { element: __payment.label || "?" },
                                      { element: __payment.value_juros ? formatReal(__payment.value_juros) : "-" },
                                      {
                                        element: (
                                          <p className="text-end">
                                            <StatusFlag status={__payment.status} />
                                          </p>
                                        ),
                                      },
                                    ],
                                  })) || [],
                              }}
                            />
                          </Accordion.Body>
                        </Accordion.Item>
                      </Col>
                    </Row>
                  </>
                );
              })}
            </Accordion>
          </div>
        );
        setBodyContent(body);
      } catch (__error) {
        console.log(__error);
        toast.error("Erro ao carregar dados, tente novamente.");
      } finally {
        setLoadingPage(false);
      }
    })();
  }, []);

  return !loadingPage ? <InfoModal title={title} body={bodyContent} size="lg" /> : "";
}
